import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/apiServices/dashboard.service';
import { DashboardVm } from 'src/app/models/ViewModels/dashboard-model';

@Component({
    selector: 'app-dashboard-main-view',
    templateUrl: './dashboard-main-view.component.html',
    styleUrls: ['./dashboard-main-view.component.scss']
})
export class DashboardMainViewComponent implements OnInit {
    public objDashboard: DashboardVm =  new DashboardVm();

    constructor(private dashboardService: DashboardService) {

     }

    ngOnInit() {
        this.dashboardService.GetStatus()
        .subscribe(
            (res) => {
                this.objDashboard = <DashboardVm>res;
            }
        );
    //     this.dashboardService.GetActiveATM()
    //     .subscribe(
    //         (res:any) => {
    //             console.log("Active ATM",res)
    //             this.objDashboard.ActiveBooth = res;
    //         }
    //     );
    //     this.dashboardService.GetActiveCustomer()
    //     .subscribe(
    //         (res:any) => {
    //             console.log("Active Customer",res)

    //             // this.objDashboard = <DashboardVm>res;
    //             this.objDashboard.ActiveCustomer = res;

    //         }
    //     );
    //     this.dashboardService.GetLatestWaterDispenses()
    //     .subscribe(
    //         (res:any) => {
    //             console.log("LatestWaterDispense",res)
    //             // this.objDashboard = <DashboardVm>res;
    //             this.objDashboard.LstWaterTransaction = res;

    //         }
    //     );
    //     // this.dashboardService.GetMonthlyWaterDispense()
    //     // .subscribe(
    //     //     (res:any) => {
    //     //         console.log("Monthy Water Dispense",res)

    //     //         // this.objDashboard = <DashboardVm>res;
    //     //         // this.objDashboard.MonthlyWaterDispense = res;

    //     //     }
    //     // );
    //     // this.dashboardService.GetNewAccountCountByMonth()
    //     // .subscribe(
    //     //     (res:any) => {
    //     //         console.log("GetNewAccountCountByMonth",res)

    //     //         // this.objDashboard = <DashboardVm>res;
    //     //         // this.objDashboard.NewAccountCountByMonth = res;

    //     //     }
    //     // );
    //     // this.dashboardService.GetPumpList()
    //     // .subscribe(
    //     //     (res:any) => {
    //     //         console.log("GetPumpList",res)

    //     //         // this.objDashboard = <DashboardVm>res;
    //     //         // this.objDashboard.LstPump = res;

    //     //     }
    //     // );
    //     // this.dashboardService.GetRechargeSumByMonth()
    //     // .subscribe(
    //     //     (res:any) => {
    //     //         console.log("GetRechargeSumByMonth",res)

    //     //         // this.objDashboard = <DashboardVm>res;
    //     //         // this.objDashboard.RechargeSumByMonth = res;

    //     //     }
    //     // );
    //     // this.dashboardService.GetTodayWaterDispense()
    //     // .subscribe(
    //     //     (res:any) => {
    //     //         console.log("GetTodayWaterDispense",res)

    //     //         // this.objDashboard = <DashboardVm>res;
    //     //         // this.objDashboard.TodayWaterDispense = res;

    //     //     }
    //     // );

    //     // this.dashboardService.GetWaterDispenseSumByMonth()
    //     // .subscribe(
    //     //     (res:any) => {
    //     //         console.log("GetWaterDispenseSumByMonth",res)

    //     //         // this.objDashboard = <DashboardVm>res;
    //     //         // this.objDashboard.WaterDispenseSumByMonth = res;

    //     //     }
    //     // );
        
    // }

    // GetActiveATM(){
    //     this.dashboardService.GetActiveATM()
    //     .subscribe(
    //         (res:any) => {
    //             console.log("Active ATM",res)
    //             this.objDashboard.ActiveBooth = res;
    //         }
    //     );
        
    // }

    // GetActiveCustomer(){
    //     this.dashboardService.GetActiveCustomer()
    //     .subscribe(
    //         (res:any) => {
    //             console.log("Active Customer",res)

    //             // this.objDashboard = <DashboardVm>res;
    //             this.objDashboard.ActiveCustomer = res;

    //         }
    //     );
        
    // }
    // GetLatestWaterDispenses(){
    //     this.dashboardService.GetLatestWaterDispenses()
    //     .subscribe(
    //         (res:any) => {
    //             // this.objDashboard = <DashboardVm>res;
    //             this.objDashboard.LstWaterTransaction = res;

    //         }
    //     );
        
    // }
    // GetMonthlyWaterDispense(){
    //     this.dashboardService.GetMonthlyWaterDispense()
    //     .subscribe(
    //         (res:any) => {
    //             console.log("Monthy Water Dispense",res)

    //             // this.objDashboard = <DashboardVm>res;
    //             this.objDashboard.MonthlyWaterDispense = res;

    //         }
    //     );
        
    // }
    // GetNewAccountCountByMonth(){
    //     this.dashboardService.GetNewAccountCountByMonth()
    //     .subscribe(
    //         (res:any) => {
    //             // this.objDashboard = <DashboardVm>res;
    //             this.objDashboard.NewAccountCountByMonth = res;

    //         }
    //     );
        
    // }
    // GetPumpList(){
    //     this.dashboardService.GetPumpList()
    //     .subscribe(
    //         (res:any) => {
    //             // this.objDashboard = <DashboardVm>res;
    //             this.objDashboard.LstPump = res;

    //         }
    //     );
        
    // }
    // GetRechargeSumByMonth(){
    //     this.dashboardService.GetRechargeSumByMonth()
    //     .subscribe(
    //         (res:any) => {
    //             // this.objDashboard = <DashboardVm>res;
    //             this.objDashboard.RechargeSumByMonth = res;

    //         }
    //     );
        
    // }
    // GetTodayWaterDispense(){
    //     this.dashboardService.GetTodayWaterDispense()
    //     .subscribe(
    //         (res:any) => {
    //             // this.objDashboard = <DashboardVm>res;
    //             this.objDashboard.TodayWaterDispense = res;

    //         }
    //     );

        
    // }
    // GetWaterDispenseSumByMonth(){
    //     this.dashboardService.GetWaterDispenseSumByMonth()
    //     .subscribe(
    //         (res:any) => {
    //             // this.objDashboard = <DashboardVm>res;
    //             this.objDashboard.WaterDispenseSumByMonth = res;

    //         }
    //     );
    // }
        }  

}
